import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import InputDialog from "./InputDialog";
import NumberPad from "./NumberPad";

/**
 * テンキーパッド入力ダイアログコンポーネント
 * @param {string} name 項目名
 * @param {string} value 値
 * @param {Function} onChange 値確定時の処理
 * @param {string} title ダイアログタイトル
 * @param {boolean} open ダイアログ表示/非表示フラグ
 * @param {Function} onClose ダイアログを閉じる際の処理
 * @class NumberPadDialog
 */
export default function NumberPadDialog({
  name,
  value,
  onChange,
  title,
  subtitle,
  open,
  onClose,
}) {
  const [localValue, setLocalValue] = useState(null);

  /**
   * 入力欄にテキストを反映する
   * @memberof NumberPadDialog
   */
  useEffect(() => {
    setLocalValue(value);
  }, [value]);
  /**
   * テキストの変更を反映し、ダイアログを閉じる
   * @memberof NumberPadDialog
   */
  const onSubmit = () => {
    onChange(name, localValue);
    onClose();
    setLocalValue(null);
  };
  return (
    <InputDialog
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      fullScreen={isMobile}
      type="number-pad"
    >
      <div className="numberpad-dialog-contents">
        <div className="keypad-display-wrap">
          <input
            className="keypad-display"
            name={name}
            type="text"
            readOnly
            value={localValue}
          />
        </div>
        <NumberPad
          defaultValue={localValue}
          onChange={setLocalValue}
          onSubmit={onSubmit}
        />
      </div>
    </InputDialog>
  );
}
